export const ROUTE_KEYS = {
	HOME: 'home',
	MANAGE_TEMPLATES: 'manage-templates',
	IMPERSONATION: 'impersonation-page',
	IMPERSONATION_SILAE: 'impersonation-silae.page',
	AUTH: 'auth',
	AUTH_RESET_PASSWORD: 'auth.reset-password',
	AUTH_CONFIRM_RESET_PASSWORD: 'auth.confirm-reset-password',
	AUTH_SIGN_IN: 'auth.sign-in',
	AUTH_SIGN_UP: 'auth.sign-up',
	AUTH_SIGN_UP_CHOOSE_PASSWORD: 'auth.sign-up.choose-password',
	AUTH_SIGN_UP_CHOOSE_USERNAME: 'auth.sign-up.choose-username',
	AUTH_SIGN_UP_SUCCESS: 'auth.sign-up.success',
	AUTH_SIGN_UP_CONFIRM: 'auth.confirm-sign-up',
	SETTINGS: 'settings',
	SETTINGS_COLLABORATORS: 'settings.collaborators',
	SETTINGS_GENERAL: 'settings.general',
	ORGANIZATION: 'organization-page',
	ORGANIZATION_ACTIVITY: 'organization.activity',
	ORGANIZATION_USERS: 'organization.users',
	ORGANIZATION_INVITATIONS: 'organization.invitations',
	ORGANIZATION_EXPENSE_TRAIL: 'organization.expense-trail',
	PRIVACY_POLICY: 'privacy-policy'
};
